import React from 'react';
import {
  CAlert,
} from '@coreui/react'
import {AlertTypes} from '../../common/enums/index'


const FormAlert = (props)=> {
  if(props.error!==''){
    return (
        <CAlert 
            color={
                props.type===AlertTypes.Alert_Danger? "danger":
                props.type===AlertTypes.Alert_Warning? "warning":
                props.type===AlertTypes.Alert_Success? "success":
                  "info"
            }
        >
            {props.error}
        </CAlert>
    )
  }
  return <p/>
}

export default FormAlert
